import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import TeamCards from "./TeamCards";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import useConfig from "../../../hooks/useConfig";
import { UserContext } from "..";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import axios from "../../../utils/axios";
import PageRoutes, { APIRoutes } from "../../../utils/constants";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import ChannelPreferencess from "../ChannelPreferences";
import ChannelCards from "../ChannelPreferences/ChannelCards";
import useCommonDetails from "../../../Common/Hooks/useCommonDetails";
import { useDispatch } from "react-redux";
import commonDetailSlice from "../../../store/reducers/commonReducer";
import QueuePlayNextIcon from "@mui/icons-material/QueuePlayNext";
import EllipsisContent from "../../../Common/Component/EllipsisContent";
import HttpService from "../../../hooks/Https-services";
import { isDebuggerStatement } from "typescript";
import SeasonCard from "../SelectSeason";

const SelectTeamm = (props: any) => {
  const configData = useConfig();
  const { handleNext, handleBack } = props;
  const navigate = useNavigate();
  const {
    selectedTeam,
    channel,
    loading,
    selectedEvent,
    setSelectedEvent,
    selectedPlayer,

    isSelectAllEvent,
    channelData,
    selectedSeason,
    setIsSelectAllEvents,
    setLoading,
    selectAllTeamPlayers,
  }: any = useContext(UserContext);

  const [all, setAll] = useState(false);
  const [select, setSelect] = useState(false);
  const [actions, setActions] = useState([
    "FACE_OFF",
    "GOAL",
    "HIT",
    "PASS",
    "PENALTY",
    "SAVE",
    "SHIFT",
    "SHOT",
  ]);
  const [isSkeleton, setIsSkeleton] = useState(false);

  const userDetails = useCommonDetails();
  const dispatch = useDispatch();
  async function getEntries(data: any) {
    let submitdata = { ...data };
    try {
      const res = await HttpService.get(APIRoutes.GetAllChannel);
      if (res?.data?.data == null || res?.data?.data?.length == 0) {
        submitdata.isChannelCreated = false;
      } else {
        submitdata.isChannelCreated = true;
      }
      dispatch(commonDetailSlice.actions.removecommonDetails());
      dispatch(commonDetailSlice.actions.setcommonDetails(submitdata));
    } catch (error) {
      console.log(error);
    }
  }
  const { channel_id }: any = useParams();
  const createChannel = async () => {
    const updateConfigure = {
      Name: channelData,
      Teams: selectedTeam,
      Players: selectedPlayer,
      Events: selectedEvent,
      All: selectAllTeamPlayers,
      Seasons: selectedSeason,
    };
    setLoading(true);
    try {
      const res = await HttpService.post(
        APIRoutes.UpdateChannel.replace(":id", channel_id),
        {
          configure: updateConfigure,
        }
      );
      await getEntries(userDetails);
      navigate(PageRoutes.PersonalChannel.replace(":id", channel_id));

      handleNext();

      setLoading(false);
    } catch (error: any) {
      toast.error(error.response.data.message);
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        mx: "auto",
        px: 2,
        minHeight: "65vh",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
      }}
    >
      <Grid sx={{ flexGrow: 1 }} container spacing={2}>
        <Grid item lg={3} xs={12}>
          <Accordion sx={{ my: 2, height: 1 }} expanded={true}>
            <AccordionSummary
              sx={{
                borderRadius: "4px",
                boxShadow: "0 .5rem 1rem rgba(0,0,0,0.15)",
                background: `linear-gradient(110deg, ${configData.secondary} 50%, ${configData.primary} 50%)`,
              }}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography variant="h6" color="white">
                Select your season{" "}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ maxHeight: "60vh", overflowX: "auto" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  height: "auto",
                  overflow: "hidden",
                }}
              >
                <SeasonCard />
              </Box>
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid item lg={3} xs={12}>
          <Accordion sx={{ my: 2, height: 1 }} expanded={true}>
            <AccordionSummary
              sx={{
                borderRadius: "4px",
                boxShadow: "0 .5rem 1rem rgba(0,0,0,0.15)",
                background: `linear-gradient(110deg, ${configData.secondary} 50%, ${configData.primary} 50%)`,
              }}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography variant="h6" color="white">
                Select your team{" "}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ maxHeight: "60vh", overflowX: "auto" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  height: "auto",
                  overflow: "hidden",
                }}
              >
                <TeamCards />
              </Box>
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid item lg={3} xs={12}>
          <Accordion sx={{ my: 2, height: 1 }} expanded={true}>
            <AccordionSummary
              sx={{
                borderRadius: "4px",
                boxShadow: "0 .5rem 1rem rgba(0,0,0,0.15)",
                background: `linear-gradient(110deg, ${configData.secondary} 50%, ${configData.primary} 50%)`,
              }}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography variant="h6" color="white">
                Select Your Players{" "}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ maxHeight: "60vh", overflowX: "auto" }}>
              <ChannelCards />
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid item lg={3} xs={12}>
          <Accordion sx={{ my: 2, height: 1 }} expanded={true}>
            <AccordionSummary
              sx={{
                borderRadius: "4px",
                boxShadow: "0 .5rem 1rem rgba(0,0,0,0.15)",
                background: `linear-gradient(110deg, ${configData.secondary} 50%, ${configData.primary} 50%)`,
              }}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography variant="h6" color="white">
                Select Your Action{" "}
              </Typography>
            </AccordionSummary>

            <AccordionDetails
              sx={{
                p: "5px",
                maxHeight: "60vh",
                overflowX: "auto",
                position: "relative",
              }}
            >
              {" "}
              <Box
                sx={{
                  display: actions?.length == 0 ? "none" : "flex",
                  justifyContent: "flex-end",
                  position: "sticky",
                  bgcolor: "white",
                  top: -8,
                  zIndex: 10,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", ml: 2 }}>
                  Select All
                </Box>
                <Checkbox
                  checked={
                    selectedEvent?.length == 0 && isSelectAllEvent
                      ? true
                      : false
                  }
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedEvent([]);
                      setIsSelectAllEvents(true);
                    } else {
                      setIsSelectAllEvents(false);
                    }
                  }}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  // alignItems:"center",
                  flexWrap: "wrap",
                  // justifyContent: "space-between",
                }}
              >
                {isSkeleton ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      py: 10,
                      width: 1,
                    }}
                  >
                    <CircularProgress
                      size={48}
                      sx={{
                        color: "#bf311a",
                      }}
                    />
                  </Box>
                ) : actions?.length == 0 || !actions ? (
                  <Typography sx={{ mx: "auto", my: 2, mb: 3.5 }}>
                    No data found
                  </Typography>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: 1,
                      p: 1.5,
                    }}
                  >
                    {actions.map((ele: any) => (
                      <Box
                        sx={{
                          py: 1,
                          maxHeight: "50%",
                          borderBottom: "1px solid #dadada",
                          display: "flex",
                          alignItems: "center",
                          width: 1,
                          justifyContent: "space-between",
                          overflowY: "hidden",
                          overflowX: "auto",
                        }}
                      >
                        <EllipsisContent text={ele?.split("_")?.join(" ")} />
                        <Checkbox
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedEvent([...selectedEvent, ele]);
                            } else {
                              const index = selectedEvent.findIndex(
                                (element: any) => element == ele
                              );
                              if (index != -1) {
                                const teamData = selectedEvent.filter(
                                  (e: any, ind: any) => ind != index
                                );

                                setSelectedEvent(teamData);
                              }
                            }
                          }}
                          checked={selectedEvent?.includes(ele) ? true : false}
                        />
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            onClick={handleBack}
            sx={{
              my: { xs: 1, md: 2 },
              textAlign: "center",
              height: "50px",
              background: configData.secondary,
              "&:hover": { background: configData.secondary },
            }}
          >
            <KeyboardArrowLeftIcon /> Back
          </Button>
        </Grid>

        <Grid item xs={12} sm={6}>
          <LoadingButton
            loading={loading}
            type="submit"
            disabled={
              (selectedEvent?.length == 0 && !isSelectAllEvent) ||
              selectedTeam?.length == 0 ||
              (selectedPlayer?.length == 0 && selectAllTeamPlayers?.length == 0)
            }
            fullWidth
            variant="contained"
            sx={{
              my: { xs: 1, md: 2 },
              textAlign: "center",
              height: "50px",
              background: configData.primary,
              "&:hover": { background: configData.primary },
            }}
            onClick={() => {
              createChannel();
            }}
          >
            BUILD YOUR CHANNEL &nbsp; <QueuePlayNextIcon />
          </LoadingButton>
        </Grid>
      </Grid>

      {/* <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={6}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              onClick={handleBack}
              sx={{
                my: { xs: 1, md: 2 },
                textAlign: "center",
                background: configData.secondary,
                "&:hover": { background: configData.secondary },
              }}
            >
              <KeyboardArrowLeftIcon /> Back
            </Button>
          </Grid>

          <Grid item xs={12} sm={6}>
            <LoadingButton
            loading={loading}
              type="submit"
              fullWidth
              disabled={step == 1 && selectedTeam?.length == 0}
              variant="contained"
              onClick={() => createChannel()}
              sx={{
                my: { xs: 1, md: 2 },
                textAlign: "center",
                background: configData.primary,
                "&:hover": { background: configData.primary },
              }}
            >
              Next <KeyboardArrowRightIcon />
            </LoadingButton>
          </Grid>
        </Grid> */}
    </Box>
  );
};

export default SelectTeamm;
